import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
window.addEventListener('beforeunload', function(event) {
    // localStorage.removeItem('accessToken');
    // localStorage.removeItem('iterationId');
    // localStorage.removeItem('companyId');
    // localStorage.removeItem('thru_email');
    // localStorage.removeItem('encryted_email');
    sessionStorage.clear()
    // Optionally, you can also remove other values or perform additional cleanup
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
    <App />
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();